import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { AppError } from '../../types/error';
import { AsyncThunkConfig } from '../../types/utility';

type State = (AppError & { raised: true }) | { raised: false };

const initialState = { raised: false } as State;

export const errorSlice = createSlice({
	name: 'error',
	initialState,
	reducers: {
		saveError(_, action: PayloadAction<AppError>) {
			return { ...action.payload, raised: true };
		}
	}
});

export const errorActions = errorSlice.actions;

export const reportError = createAsyncThunk<void, AppError, AsyncThunkConfig>(
	'error/report',
	async (error, { dispatch }) => {
		dispatch(
			errorActions.saveError({
				...error,
				reason: JSON.stringify(error.reason)
			})
		);
		// report error to sentry
	},
	{
		dispatchConditionRejection: false
	}
);

export const selectError = (state: RootState) => state.error;
export const selectErrorType = (state: RootState) => {
	const error = selectError(state);
	if ('type' in error) return error.type;
};
export const selectErrorMessage = (state: RootState) => {
	const error = selectError(state);
	if ('message' in error) return error.message;
};
export const selectErrorObject = (state: RootState) => {
	const error = selectError(state);
	if ('errorObject' in error) return error.errorObject;
};
